<br>
<button style="background-color: rgb(207, 51, 3);" (click)="printpdf()" mat-raised-button>Exportar a PDF <mat-icon>picture_as_pdf</mat-icon></button>
<div>
    <pdf-viewer [src]="src" [render-text]="true" [zoom]="0.7" [show-borders]="true" [original-size]="false" style="width: auto; height: 800px"></pdf-viewer>
</div>


